import { c as _c } from "react/compiler-runtime";
export const DisabledBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-caption-strong text-status-error-text">Unavailable with your selection</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};